// extracted by mini-css-extract-plugin
export default {"root":"Header_root__13Mss","root_background":"Header_root_background__ZlG2d","container":"Header_container__trV20","promo":"Header_promo__6047J","header":"Header_header__BoS7N"};